import {SubCategoryProps} from 'modules/sub-categories/types';
import subCategoriesKeys from 'modules/sub-categories/util/sub-categories-keys';
import React from 'react';
import {IoTrash} from 'react-icons/io5';
import List from 'shared/layout/list';
import ApiDynamicButton from 'shared/migration-components/api-dynamic-button';
import ApiSwitch from 'shared/migration-components/api-switch';
import useProjection from 'shared/migration-hooks/use-projection';

const SubCategories: React.FC = () => {
  const projection = useProjection<SubCategoryProps>('subCategories', [
    'name',
    'active',
    'category.name',
    'id',
  ]);

  return (
    <List<SubCategoryProps>
      {...{
        titleBar: {
          title: 'Sub categorias',
          actionButton: {title: 'NOVA SUB CATEGORIA', to: 'create'},
        },
        table: {
          url: '/sub-categories',
          projection: {
            ...projection,
            options: [
              'name',
              'category.name',
              {
                value: 'active',
                column: {
                  value: (row) => (
                    <ApiSwitch
                      multipart
                      isChecked={row.active}
                      url={`/sub-categories/${row.id}`}
                      queryKey={subCategoriesKeys.list()}
                    />
                  ),
                  stopPropagation: true,
                },
                filter: {
                  type: 'select',
                  values: [
                    {
                      label: 'Sim',
                      value: true,
                    },
                    {
                      label: 'Não',
                      value: false,
                    },
                  ],
                },
              },
              {
                value: 'id',
                label: 'Ações',
                column: (row) => (
                  <ApiDynamicButton
                    keys={{deleteInfiniteList: subCategoriesKeys.list()}}
                    button={{
                      icon: <IoTrash />,
                      tooltip: 'Remover sub categoria',
                    }}
                    request={{
                      errorTitle: 'Erro ao remover sub categoria',
                      method: 'DELETE',
                      url: `/sub-categories/${row.id}`,
                    }}
                    confirmButtonText="produto"
                  />
                ),
              },
            ],
          },
          translatedPropsKey: 'SubCategoryProps',
        },
        queryKey: subCategoriesKeys.list(),
      }}
    />
  );
};

export default SubCategories;
